export default {
	Accept: 'application/vnd.api+json'
};
